module.exports = __webpack_public_path__ + "static/scale-model-of-woody-guthrie-center-in-tulsa-oklahoma-9c93bcb1dc0560ee67e2237f844db3d4.png";